import FrontEndApi from '../../../../Common/Globals/Scripts/FrontEndApi';

async function loadRateCard(rateCardId) {
    const response = await FrontEndApi.getViewableRateCardsByIds([rateCardId]);

    if(response.length > 1) {
        throw Error(`Expected 0 or 1 rate cards, but got ${response.length}. This is a bug in the app.`);
    }

    return response.length === 0 ? null : response[0];
}

export default { loadRateCard }
